import { colors } from '@mui/material';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#713FA6',
    main: '#ad86bd',
    light: '#C68FFF'
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400']
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
    ultralight: colors.green[200]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
    ultralight: colors.orange[200]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
    ultralight: colors.red[200]
  },
  disabled: {
    contrastText: white,
    dark: colors.grey[900],
    main: colors.grey[600],
    light: colors.grey[400],
    ultralight: colors.grey[200]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  shadows: {
    primary: '#C68FFF'
  },
  background: {
    default: '#BD84FA',
    paper: white
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200]
};
